module.exports = __webpack_public_path__ + "assets/新增房源.8d70224c.svg";